import { render, staticRenderFns } from "./addTeipBizUser.vue?vue&type=template&id=ead1cfaa&"
import script from "./addTeipBizUser.vue?vue&type=script&lang=ts&"
export * from "./addTeipBizUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports